module.exports = __webpack_public_path__ + "assets/img/monitoring-screenshot.12a147b8.png";